import React from "react";
import { RCCBadge, RCCHidden } from "react-common-components";
import { useHistory } from "react-router-dom";
import { useTranslation } from "src/context/Translations/context";
import { CheckQuadrant, GroupersRisks, RisksSituation } from "src/pages/Risks/Panel/interface";
import { IDashboardRisksData } from "../interface";

interface ILI{
  data?: IDashboardRisksData;
	filterListQuadrant: CheckQuadrant | undefined
}

const Li: React.FC<ILI> = ({
	data,
	filterListQuadrant
}) => {

	const { translate } = useTranslation();
	const history = useHistory();
	
	return (
		<>
			<div>
				<RCCBadge color="purple" layout="isSquare" 
					onClick={() => history.push(`/risks/panel/?group=${GroupersRisks.RISK_CLASSIFICATION}&classification=${data?.id}&situation=${RisksSituation.ALL}&quadrant=${filterListQuadrant ?? ""}`)} 
				>
					{data?.total || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Total")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="blue" layout="isSquare" 
					onClick={() => history.push(`/risks/panel/?group=${GroupersRisks.RISK_CLASSIFICATION}&classification=${data?.id}&situation=${RisksSituation.OPEN}&quadrant=${filterListQuadrant ?? ""}`)}
				>
					{data?.open || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Aberto")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="green" layout="isSquare" 
					onClick={() => history.push(`/risks/panel/?group=${GroupersRisks.RISK_CLASSIFICATION}&classification=${data?.id}&situation=${RisksSituation.FINALY}&quadrant=${filterListQuadrant ?? ""}`)}
				>
					{data?.closed || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Finalizado")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="grey" layout="isSquare" >{data?.mediumDegree	 || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Grau médio")}
				</RCCHidden>
			</div>
			<div>
				<RCCBadge color="red" layout="isSquare" >{data?.incidences || 0}</RCCBadge>
				<RCCHidden mdUp>
					{translate("Incidências")}
				</RCCHidden>
			</div>
		</>
	);
};

export default Li;
